const mapOAIToTradier = (symbol?: string) => {
  return symbol;
};

export default mapOAIToTradier;
